// Compiled at 2026-09-18T12:45:23.821Z
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { NavigationSkipped } from "@angular/router";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import type { ValidationRules } from "@lg/shared";
import { BoInfoSymbol } from "@lg/shared/for-apps";
import { ProxyTargetSymbol } from "@lg/shared/for-apps";
import { Semaphore } from "@lg/shared/for-apps";
import { memoize } from "@lg/shared/for-apps";
import { NgSharedModule } from "@lg/ng-shared";
import { combineLatest, filter } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";
import { MainLayout as Orders__MainLayout } from "../Orders/MainLayout.js";
import { GenericTableComponent } from "@lg/ng-shared";
import { MatTableModule } from "@angular/material/table";
import { RouterLink } from "@angular/router";

interface Properties {
    filter: string;
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Orders-CustomerRequestList',
    templateUrl: './CustomerRequestList.html',
    styleUrls: ['./CustomerRequestList.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgSharedModule,
        Orders__MainLayout,
        GenericTableComponent,
        MatTableModule,
        RouterLink
    ],
})
export class CustomerRequestList extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Orders.CustomerRequestList';
    $isDialog = false;
    $Modules = $Modules;
    Orders = Orders;
    System = System;
    Common = Common;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    @Output()
    submit = new EventEmitter<This.CustomerRequest>();
    output = {
        submit: async (data: This.CustomerRequest, followNextUserTask = true) => {
            data = (data as any)?.$clone ? (data as any).$clone() : data
            let result: any
            result = await (followNextUserTask ? Sys.Process.driveProcessAndFollowNextUserTask : Sys.Process.driveProcess)('submit', data)
            this.submit.emit(data)
            if (this.dialogData?.closeOnOutput === 'submit') { this.dialogRef?.close(data) }
            return result
        },
    };
    _DataTableBlock_columns_100 = (screen: Properties) => ['requestId', 'name', 'materials', 'request.status'];
    $validators: Record<number, ValidationRules> = {

    };
    var_filter = computed(() => coerceDataType(this.queryParams()?.filter ?? '', 'string', false, true));
    readonly screen =
        ((component: typeof this) => {
            return {
                get filter() { return component.var_filter() }
            }
        })(this)
        ;

    get $inputs() {
        return {

        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }


    }

    async ngAfterViewInit(): Promise<void> {
    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this

            this.$isVariablesInitialized.set(true)
        })

        effect(() => {
            if (!this.$isVariablesInitialized()) return
            if (!this.$isOnInitCalled) {
                this.$isOnInitCalled = true
                setTimeout(async () => {
                    await this.action_onInit()
                    this.$isFullyInitialized.set(true)
                })
            }
        })



    }

    _DataTableBlock_additionalFindOptions_100($scope: any): any {
        let { app, screen, $pathSegments, $disabled }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean } = $scope ?? {}

        return ({
            relations: {
                request: true,
                materials: true,
            },
            order: {
                requestId: 'desc',
                id: 'desc',
            }
        })
    }

    _DataTableColumnBlock_cellText_101($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: Orders.CustomerRequestItem, index: number } = $scope ?? {}

        return (item.name)
    }

    _DataTableColumnBlock_cellText_106($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: Orders.CustomerRequestItem, index: number } = $scope ?? {}

        return (item.materials.map(m => m.name).join(' / '))
    }

    _DataTableColumnBlock_cellText_105($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: Orders.CustomerRequestItem, index: number } = $scope ?? {}

        return (item.request?.status.label)
    }

    async action_onInit($event?: any) {
        const { app, screen, output } = this
        {

        }
    }
}
